import React, { useState } from 'react';
import { getMappedValueFromOrderOrItem } from '../../../../../util';
import {
  ResultsColumnEllipsis,
  ResultsArrayItemsNumberBadge,
  MoreInfoDropdownButton,
  ResultsTextEllipsis,
  ResultsTextArray,
  ResultArrayWrapper,
  ResultsColumn,
} from '../../DTInfoWidget.styles';

const ArrayInText = ({ arrayData, selectedItem, orderingSystem }) => {
  const [isArrayInfoOpen, setIsArrayInfoOpen] = useState(true);

  const values = getMappedValueFromOrderOrItem(selectedItem, arrayData, orderingSystem);

  if (!values?.length) {
    return <ResultsColumn key={`data_${arrayData.dataPath}`}>{String(values)}</ResultsColumn>;
  }

  return (
    <ResultArrayWrapper>
      <ResultsColumnEllipsis>
        <ResultsArrayItemsNumberBadge>{values.length}</ResultsArrayItemsNumberBadge>
        <ResultsTextEllipsis key={`data_${arrayData.dataPath}`}>{String(values)}</ResultsTextEllipsis>
        <MoreInfoDropdownButton
          src={
            isArrayInfoOpen ? '/images/new-designs/chevron-up-black.svg' : '/images/new-designs/chevron-down-black.svg'
          }
          alt="Show Items Array"
          onClick={() => setIsArrayInfoOpen(!isArrayInfoOpen)}
        />
      </ResultsColumnEllipsis>

      {isArrayInfoOpen && (
        <ResultArrayWrapper>
          {values.map((value, idx) => (
            <ResultsTextArray key={`value_array_${idx}`}>{String(value)}</ResultsTextArray>
          ))}
        </ResultArrayWrapper>
      )}
    </ResultArrayWrapper>
  );
};

export default ArrayInText;
